import Vue from 'vue'

const initialState = {
  projectsGroupBy: 'Created At',
  clientsGroupBy: 'Created At',
  appBuildsGroupBy: 'Created At',
  dashboardLogListView: 'day',
  projectsTypeFilter: [],
  projectsStatusFilter: [],
  clientsStatusFilter: [],
  wipUsersFilter: []
}

export default {
  state: { ...initialState },
  mutations: {
    SET_PROJECTS_GROUP_BY (state, projectsGroupBy) {
      state.projectsGroupBy = projectsGroupBy
    },

    SET_CLIENTS_GROUP_BY (state, clientsGroupBy) {
      state.clientsGroupBy = clientsGroupBy
    },

    SET_APP_BUILDS_GROUP_BY (state, appBuildsGroupBy) {
      state.appBuildsGroupBy = appBuildsGroupBy
    },

    SET_PROJECTS_TYPE_FILTER (state, projectsTypeFilter) {
      state.projectsTypeFilter = projectsTypeFilter
    },

    SET_PROJECTS_STATUS_FILTER (state, projectsStatusFilter) {
      state.projectsStatusFilter = projectsStatusFilter
    },

    SET_CLIENTS_STATUS_FILTER (state, clientsStatusFilter) {
      state.clientsStatusFilter = clientsStatusFilter
    },

    SET_DASHBOARD_LOG_LIST_VIEW (state, dashboardLogListView) {
      state.dashboardLogListView = dashboardLogListView
    },

    SET_WIP_USERS_FILTER (state, wipUsersFilter) {
      state.wipUsersFilter = wipUsersFilter
    },

    FILTERS_CLEAR_ALL (state) {
      for (let key in initialState) {
        Vue.set(state, key, initialState[key])
      }
    }
  },
  actions: {
    setProjectsGroupBy ({commit}, projectsGroupBy) {
      commit('SET_PROJECTS_GROUP_BY', projectsGroupBy)
    },
    setClientsGroupBy ({commit}, clientsGroupBy) {
      commit('SET_CLIENTS_GROUP_BY', clientsGroupBy)
    },
    setAppBuildsGroupBy ({commit}, clientsGroupBy) {
      commit('SET_APP_BUILDS_GROUP_BY', clientsGroupBy)
    },
    setProjectsTypeFilter ({commit}, projectsTypeFilter) {
      commit('SET_PROJECTS_TYPE_FILTER', projectsTypeFilter)
    },
    setProjectsStatusFilter ({commit}, projectsStatusFilter) {
      commit('SET_PROJECTS_STATUS_FILTER', projectsStatusFilter)
    },
    setClientsStatusFilter ({commit}, clientsStatusFilter) {
      commit('SET_CLIENTS_STATUS_FILTER', clientsStatusFilter)
    },
    setDashboardLogListView ({commit}, dashboardLogListView) {
      commit('SET_DASHBOARD_LOG_LIST_VIEW', dashboardLogListView)
    },
    setWipUsersFilter ({commit}, wipUsersFilter) {
      commit('SET_WIP_USERS_FILTER', wipUsersFilter)
    }
  }
}
